// import React, { useEffect, useState } from "react";
// import { Home, ArrowLeft } from "lucide-react";
// import { getSubscriptions } from "../../lib/Subscription";

// export default function BuyRenewConfirmationPage() {
//   const [subscription, setSubscription] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     fetchSubscription();
//   }, []);

//   const fetchSubscription = async () => {
//     try {
//       const userId = 69; // replace with logged-in user id if needed
//       const res = await getSubscriptions(userId);

//       if (res?.success && res?.data?.length > 0) {
//         setSubscription(res.data[0]);
//       }
//     } catch (error) {
//       console.error("Subscription fetch error:", error);
//     } finally {
//       setLoading(false);
//     }
//   };
// console.log("Response data:",subscription);
//   if (loading) {
//     return (
//       <div className="min-h-screen flex items-center justify-center bg-secondary text-xl">
//         Loading subscription details...
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-secondary font-sans px-4 md:px-10 py-6">
//       {/* Top Header */}
//       <div className="flex items-start justify-between mb-8">
//         <div>
//           <div className="w-[220px] h-[90px] bg-black rounded-xl flex items-center justify-center text-white text-4xl font-bold shadow-card">
//             InstaED
//           </div>
//           <p className="text-xl md:text-2xl mt-3 text-black">
//             Online Tuitions | 6-12
//           </p>
//         </div>

//         <img
//           src="https://i.pravatar.cc/60?img=32"
//           alt="profile"
//           className="w-14 h-14 rounded-full object-cover"
//         />
//       </div>

//       {/* Purple Bar */}
//       <div className="bg-primary rounded-lg px-6 py-5 flex items-center justify-between text-white mb-16">
//         <h1 className="text-2xl md:text-3xl font-semibold">
//           Buy | Renew Re-confirmation
//         </h1>

//         <div className="flex items-center gap-5">
//           <button>
//             <Home size={30} />
//           </button>
//           <button>
//             <ArrowLeft size={30} />
//           </button>
//         </div>
//       </div>

//       {/* Main Content */}
//       <div className="max-w-4xl mx-auto">
//         <h2 className="text-3xl font-semibold text-center mb-14">
//           Hi, you are renewing your subscription to InstaED.
//         </h2>

//         <div className="space-y-8 text-lg md:text-xl">
//           <InfoRow
//             label="Current class"
//             value={
//               <div className="flex flex-wrap items-center gap-3">
//                 <span>Class 9</span>
//                 <span className="text-red-500 text-base md:text-lg">
//                   (Academic year expired)
//                 </span>
//               </div>
//             }
//           />

//           <InfoRow
//             label="Subscribing / renewing to"
//             value={subscription?.className || "-"}
//           />
//            <InfoRow
//             label="Subjects"
//             value={subscription?.subjectName || "-"}
//           />

//           <InfoRow
//             label="Plan Type"
//             value={subscription?.planType || "-"}
//           />

//           <InfoRow
//             label="Academic session"
//             value={`${formatDate(subscription?.startDate)} - ${formatDate(subscription?.endDate)}`}
//           />

//           <InfoRow
//             label="Weekdays opted"
//             value={<CheckedText text={subscription?.batchType || "-"} />}
//           />

//           <InfoRow
//             label="Payment Method opted "
//             value={subscription?.paymentId || "-"}
//           />
//         </div>

//         <div className="flex flex-col items-center mt-16 gap-5">
//           <button className="bg-black text-white px-12 py-4 rounded-lg text-xl font-medium shadow-card">
//             Proceed to pay
//           </button>

//           <button className="text-xl underline text-black/70">
//             Refund policy
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// function InfoRow({ label, value }) {
//   return (
//     <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-start">
//       <div className="text-primary font-semibold">{label}:</div>
//       <div className="text-black">{value}</div>
//     </div>
//   );
// }

// function CheckedText({ text }) {
//   return (
//     <div className="flex items-center gap-4">
//       <div className="w-9 h-9 border-[3px] border-black rounded-sm flex items-center justify-center text-2xl font-bold">
//         ✓
//       </div>
//       <span>{text}</span>
//     </div>
//   );
// }

// function formatDate(date) {
//   if (!date) return "-";

//   return new Date(date).toLocaleDateString("en-GB", {
//     day: "2-digit",
//     month: "short",
//     year: "numeric",
//   });
// }




// import React, { useEffect, useState } from "react";
// import { Home, ArrowLeft } from "lucide-react";
// import axios from "axios";

// const ReconfirmationPage = () => {
//   const [apiData, setData] = useState(null);

//   useEffect(() => {
//     fetchData();
//   }, []);

//   // ✅ FETCH DATA
//   const fetchData = async () => {
//     try {
//       const response = await axios.get(
//         "http://localhost:5050/LiveClasses/GetSubscriptions",
//         {
//           params: { userId: 69 },
//           headers: {
//             Authorization: `Bearer YOUR_TOKEN_HERE`, // 🔥 replace with real token
//           },
//         }
//       );

//       console.log("API RESPONSE 👉", response.data);

//       const res = response.data;

//       if (res.success && res.data.length > 0) {
//         const d = res.data[0];

//         setData({
//           id: d.id,
//           courseId: d.assignedCourseId,
//           sessionId: d.sessionId,
//           batchId: d.batchId,
//           planType: d.planType,
//           startDate: d.startDate,
//           endDate: d.endDate,
//           paymentId: d.paymentId,
//           sessionName: d.sessionName,
//           batchType: d.batchType,
//         });
//       } else {
//         console.warn("No data found ❌");
//       }
//     } catch (err) {
//       console.error("API ERROR", err);
//     }
//   };

//   // ✅ LOADING STATE
//   if (!apiData) {
//     return (
//       <div className="flex justify-center items-center h-screen">
//         <p>Loading...</p>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-[#f5f1eb]">
//       {/* HEADER */}
//       <div className="bg-[#6b57a5] text-white flex justify-between items-center px-8 py-4 rounded-md m-4">
//         <h1 className="text-lg font-semibold">
//           Buy | Renew Re-confirmation
//         </h1>

//         <div className="flex gap-6">
//           <Home className="cursor-pointer" />
//           <ArrowLeft className="cursor-pointer" />
//         </div>
//       </div>

//       {/* CONTENT */}
//       <div className="max-w-3xl mx-auto mt-16">
//         <h2 className="text-center text-xl font-semibold mb-16">
//           Hi, you are renewing your subscription to InstaED.
//         </h2>

//         <div className="space-y-6">
//           <div className="flex justify-between">
//             <span className="text-[#6b57a5] font-medium">Course ID</span>
//             <span>{apiData.courseId}</span>
//           </div>

//           <div className="flex justify-between">
//             <span className="text-[#6b57a5] font-medium">Batch</span>
//             <span>{apiData.batchType}</span>
//           </div>

//           <div className="flex justify-between">
//             <span className="text-[#6b57a5] font-medium">Plan</span>
//             <span>{apiData.planType}</span>
//           </div>

//           <div className="flex justify-between">
//             <span className="text-[#6b57a5] font-medium">Start Date</span>
//             <span>
//               {apiData.startDate
//                 ? new Date(apiData.startDate).toLocaleDateString()
//                 : "-"}
//             </span>
//           </div>

//           <div className="flex justify-between">
//             <span className="text-[#6b57a5] font-medium">End Date</span>
//             <span>
//               {apiData.endDate
//                 ? new Date(apiData.endDate).toLocaleDateString()
//                 : "-"}
//             </span>
//           </div>
//         </div>

//         {/* BUTTON */}
//         <div className="text-center mt-16">
//           <button className="bg-black text-white px-10 py-3 rounded-md">
//             Proceed to pay
//           </button>

//           <p className="mt-4 text-sm underline cursor-pointer">
//             Refund policy
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ReconfirmationPage;



import React from "react";
import { ArrowLeft } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import Logo from "../../components/common/Logo";
import { buySubscription } from "../../lib/Subscription";

const ReconfirmationPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [submitError, setSubmitError] = React.useState("");

  // Data coming directly from SubscriptionPage
  const data = location.state;

  // ---------------------------------------------------------
  // If page is opened directly without subscription data
  // ---------------------------------------------------------
  if (!data) {
    return (
      <div className="min-h-screen bg-[#F7F3EA] flex items-center justify-center px-4">
        <div className="w-full max-w-md bg-white rounded-2xl border border-[#E3DAC9] p-8 text-center">
          <h2 className="text-xl font-bold text-[#17144B] mb-3">
            Subscription details not found
          </h2>

          <p className="text-sm text-[#6F6887] mb-6">
            Please go back to the subscription page and select
            your subscription details again.
          </p>

          <button
            type="button"
            onClick={() => navigate("/subscription")}
            className="
              bg-[#1D194E]
              text-white
              px-6
              py-3
              rounded-full
              text-sm
              font-semibold
              hover:bg-[#15123D]
              transition
            "
          >
            Go to Subscription
          </button>
        </div>
      </div>
    );
  }

  // ---------------------------------------------------------
  // Safe values
  // ---------------------------------------------------------

  const currentClass =
    data.currentClassName || "Class 7";

  const subscribingClass =
    data.selectedClassName || "-";

  const subjects =
    Array.isArray(data.subjects) &&
      data.subjects.length > 0
      ? data.subjects.join(", ")
      : "-";

  const academicSession =
    data.academicSession ||
    "Apr 2026 – Mar 2027";

  const weekday =
    data.weekday || "-";

  const planName =
    data.planName || "-";

  const amount =
    Number(data.amount || 0);

  const paymentMethod =
    data.paymentMethod || "-";

  const subscriptionType =
    data.subscriptionType || "Renewal";

  // BuySubscription expects dates as dd-MM-yyyy.
  const formatApiDate = (value) => {
    if (!value) return null;

    const dateText = String(value).slice(0, 10);
    const isoParts = dateText.split("-");

    if (isoParts.length === 3 && isoParts[0].length === 4) {
      const [year, month, day] = isoParts;
      return `${day}-${month}-${year}`;
    }

    return dateText;
  };

  // ---------------------------------------------------------
  // Proceed to Pay
  // ---------------------------------------------------------

  const handleProceedToPay = async () => {
    if (isSubmitting) return;

    try {
      setIsSubmitting(true);
      setSubmitError("");

      const storedUser = JSON.parse(
        localStorage.getItem("user") || "{}"
      );

      const schoolId =
        data.schoolId ||
        storedUser?.SchoolId ||
        storedUser?.schoolId ||
        storedUser?.SchoolID ||
        localStorage.getItem("schoolId") ||
        0;

      const payload = {
        userId: Number(data.userId),
        schoolId: Number(schoolId),
        classId: Number(data.selectedClassId),
        selectedBatches: data.selectedBatches || [],
        packageId: Number(data.packageId) || 0,
        courseIds: (data.selectedCourseIds || []).map(Number),
        startDate: formatApiDate(data.startDate),
        endDate: formatApiDate(data.endDate),
        planId: Number(data.planId),
        amount,
        paymentStatus: "SUCCESS",
        paymentMode: paymentMethod,
        paymentId: "pay_test_123",
        razorpayOrderId: "order_test_123",
      };

      const response = await buySubscription(payload);

      if (!response?.success) {
        throw new Error(
          response?.message || "Subscription could not be created."
        );
      }

      alert("Subscription created successfully.");
      navigate("/live-classes", { replace: true });
    } catch (error) {
      console.error("Buy subscription API error:", error);
      setSubmitError(
        error?.response?.data?.message ||
        error?.message ||
        "Subscription failed. Please try again."
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div
      className="
        min-h-screen
        bg-[#F7F3EA]
        text-[#17144B]
      "
    >
      <div
        className="
          w-full
          max-w-[1180px]
          mx-auto
          px-4
          sm:px-6
          lg:px-8
          py-5
          sm:py-7
        "
      >

        {/* =====================================================
            LOGO HEADER
        ===================================================== */}

        <header
          className="
            flex
            items-start
            justify-between
            mb-6
          "
        >

          {/* EXISTING LOGO COMPONENT */}

          <div className="cursor-pointer">
            <Logo />
          </div>

          {/* BACK BUTTON */}

          <button
            type="button"
            onClick={() => navigate(-1)}
            className="
              mt-2
              w-9
              h-9
              sm:w-10
              sm:h-10
              rounded-full
              flex
              items-center
              justify-center
              text-[#201A55]
              hover:bg-white
              transition
              shrink-0
            "
            aria-label="Go back"
          >
            {/* <ArrowLeft
              size={22}
              strokeWidth={1.8}
            /> */}
          </button>

        </header>


        {/* =====================================================
            PURPLE TITLE BAR
        ===================================================== */}

        <div
          className="
            w-full
            bg-[#4036CC]
            rounded-[10px]
            sm:rounded-[12px]
            min-h-[62px]
            sm:min-h-[70px]
            px-5
            sm:px-7
            flex
            items-center
            justify-between
            mb-6
          "
        >

          <h1
            className="
              text-white
              text-[17px]
              sm:text-[21px]
              md:text-[24px]
              font-bold
              leading-tight
            "
          >
            Buy | Renew Re-confirmation
          </h1>

          <button
            type="button"
            onClick={() => navigate(-1)}
            className="
              text-white
              text-xl
              sm:text-2xl
              hover:opacity-70
              transition
            "
            aria-label="Back"
          >
            ←
          </button>

        </div>


        {/* =====================================================
            MAIN CARD
        ===================================================== */}

        <main
          className="
            w-full
            bg-white
            border
            border-[#E3DAC9]
            rounded-[14px]
            sm:rounded-[16px]
            shadow-[0_2px_8px_rgba(40,30,80,0.04)]
            px-4
            sm:px-6
            md:px-8
            lg:px-10
            py-6
            sm:py-8
          "
        >

          {/* =================================================
              TITLE
          ================================================= */}

          <h2
            className="
              text-center
              text-[#17144B]
              text-[20px]
              sm:text-[24px]
              md:text-[27px]
              font-bold
              leading-tight
              mb-7
              sm:mb-8
            "
          >
            Hi, you are{" "}
            {subscriptionType === "New"
              ? "subscribing"
              : "renewing"}{" "}
            your subscription to InstaED.
          </h2>


          {/* =================================================
              DETAILS TABLE
          ================================================= */}

          <div
            className="
              w-full
              border
              border-[#E3DAC9]
              rounded-[12px]
              overflow-hidden
            "
          >

            {/* CURRENT CLASS */}

            <InfoRow
              label="Current class"
              value={
                <div
                  className="
                    flex
                    flex-wrap
                    items-center
                    gap-x-2
                    gap-y-1
                  "
                >
                  <span>
                    {currentClass}
                  </span>

                  {data.currentAcademicExpired && (
                    <span
                      className="
                        text-[#D84732]
                        text-[13px]
                        sm:text-[14px]
                      "
                    >
                      (Academic year expired)
                    </span>
                  )}
                </div>
              }
            />


            {/* SUBSCRIBING CLASS */}

            <InfoRow
              label="Subscribing / renewing to"
              value={subscribingClass}
            />


            {/* SUBSCRIPTION TYPE */}

            <InfoRow
              label="Subscription type"
              value={subscriptionType}
            />


            {/* SUBJECTS */}

            <InfoRow
              label="Subjects"
              value={subjects}
            />


            {/* ACADEMIC SESSION */}

            <InfoRow
              label="Academic session"
              value={academicSession}
            />


            {/* WEEKDAYS */}

            <InfoRow
              label="Weekdays opted"
              value={
                <div className="flex items-center gap-2">
                  <span
                    className="
                      w-[18px]
                      h-[18px]
                      rounded-[4px]
                      bg-[#4036CC]
                      text-white
                      flex
                      items-center
                      justify-center
                      text-[11px]
                      font-bold
                    "
                  >
                    ✓
                  </span>

                  <span>
                    {weekday}
                  </span>
                </div>
              }
            />


            {/* PAYMENT PLAN */}

            <InfoRow
              label="Payment plan opted"
              value={
                <div className="flex flex-wrap items-center gap-1">
                  <span>
                    {planName}
                  </span>

                  <span>—</span>

                  <span className="font-bold">
                    ₹
                    {amount.toLocaleString(
                      "en-IN"
                    )}
                  </span>
                </div>
              }
            />


            {/* PAYMENT METHOD */}

            <InfoRow
              label="Payment method opted"
              value={paymentMethod}
              last
            />

          </div>


          {/* =================================================
              ACTION BUTTONS
          ================================================= */}

          <div
            className="
              flex
              flex-col
              sm:flex-row
              items-center
              justify-center
              gap-3
              sm:gap-4
              mt-7
              sm:mt-8
            "
          >

            {submitError && (
              <p className="w-full text-center text-sm text-red-600 mb-3">
                {submitError}
              </p>
            )}

            <button
              type="button"
              onClick={handleProceedToPay}
              disabled={isSubmitting}
              className="
                w-full
                sm:w-auto
                min-w-[190px]
                h-[48px]
                px-7
                rounded-full
                bg-[#211B56]
                text-white
                text-[14px]
                sm:text-[15px]
                font-semibold
                hover:bg-[#17123F]
                transition
                active:scale-[0.98]
              "
              >
              {isSubmitting ? "Processing..." : "Proceed to pay"}
            </button>

            <button
              type="button"
              onClick={() =>
                navigate("/refund-policy")
              }
              className="
                text-[#4036CC]
                text-[14px]
                sm:text-[15px]
                hover:underline
              "
            >
              Refund policy
            </button>

          </div>

        </main>


        {/* =====================================================
            FOOTER
        ===================================================== */}

        <footer
          className="
            mt-8
            sm:mt-10
            border-t
            border-[#E2DACA]
            pt-5
            pb-3
          "
        >

          <div
            className="
              flex
              flex-wrap
              items-center
              justify-center
              gap-x-5
              gap-y-2
              text-[10px]
              sm:text-[11px]
              text-[#6F6887]
            "
          >

            <button
              type="button"
              onClick={() =>
                navigate("/terms-condition")
              }
              className="
                hover:text-[#4036CC]
                transition
              "
            >
              Terms of use
            </button>

            <button
              type="button"
              onClick={() =>
                navigate("/policy")
              }
              className="
                hover:text-[#4036CC]
                transition
              "
            >
              Privacy policy
            </button>

            <span>
              © 2026
            </span>

          </div>

        </footer>

      </div>
    </div>
  );
};


/* ============================================================
   INFO ROW
============================================================ */

function InfoRow({
  label,
  value,
  last = false,
}) {
  return (
    <div
      className={`
        grid
        grid-cols-1
        sm:grid-cols-[210px_minmax(0,1fr)]
        ${!last
          ? "border-b border-[#E3DAC9]"
          : ""
        }
      `}
    >

      {/* LABEL */}

      <div
        className="
          px-4
          sm:px-5
          py-3.5
          sm:py-4
          text-[13px]
          sm:text-[15px]
          md:text-[16px]
          font-semibold
          text-[#17144B]
          bg-[#FFFDF9]
        "
      >
        {label}
      </div>


      {/* VALUE */}

      <div
        className="
          px-4
          sm:px-5
          py-3.5
          sm:py-4
          text-[13px]
          sm:text-[15px]
          md:text-[16px]
          text-[#25205F]
          break-words
          min-w-0
        "
      >
        {value}
      </div>

    </div>
  );
}

export default ReconfirmationPage;
